/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TaskstemplatesidTaskTemplate from './TaskstemplatesidTaskTemplate';

/**
 * The TemplatesIdBody3 model module.
 * @module model/TemplatesIdBody3
 * @version v0.3
 */
export default class TemplatesIdBody3 {
  /**
   * Constructs a new <code>TemplatesIdBody3</code>.
   * @alias module:model/TemplatesIdBody3
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TemplatesIdBody3</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TemplatesIdBody3} obj Optional instance to populate.
   * @return {module:model/TemplatesIdBody3} The populated <code>TemplatesIdBody3</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TemplatesIdBody3();
      if (data.hasOwnProperty('task_template'))
        obj.taskTemplate = TaskstemplatesidTaskTemplate.constructFromObject(data['task_template']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TaskstemplatesidTaskTemplate} taskTemplate
 */
TemplatesIdBody3.prototype.taskTemplate = undefined;

